import React from 'react'
import { formatNumber } from '@/utils/numberUtilities'

const style = { float: 'right' }
function FloatRenderer ({ value }) {
  const formatted = formatNumber(value)
  return <span style={style}>{formatted}</span>
}

export { FloatRenderer }



// WEBPACK FOOTER //
// ./src/components/report-tables/renderers/floatRenderer.js